import React from 'react';
import { Box, Link, Typography } from '../shared/MaterialUI';

const processorNames = { stax: 'Stax', paytrace: 'PayTrace' };

const PaymentProcessorInfo = ({ processor, updateUrl }) => (
  <Box mb={1}>
    <Typography variant='subtitle1'>
      Payment processor: <strong>{processorNames[processor] || 'Unavailable'}</strong>
    </Typography>
    {processor === 'stax' && updateUrl && (
      <Typography variant='body2'>
        Send the customer this link to update their Stax card:{' '}
        <Link href={updateUrl} target='_blank' rel='noopener noreferrer'>
          {updateUrl}
        </Link>
      </Typography>
    )}
  </Box>
);

export default PaymentProcessorInfo;
